import React from 'react';
import { Phone, MessageSquare } from 'lucide-react';
import { SITE } from '@/data/site-config';

export function MobileCta() {
  return (
    <div className="mobile-cta md:hidden" data-testid="mobile-cta">
      <div className="flex gap-2">
        <a href={`tel:${SITE.phoneE164}`} className="btn btn-primary flex-1" data-testid="mcta-call"><Phone size={16} /> Call</a>
        <a href={`sms:${SITE.phoneE164}`} className="btn btn-secondary flex-1" data-testid="mcta-text"><MessageSquare size={16} /> Text</a>
      </div>
    </div>
  );
}
